import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    aops: [],
    regions: [],
  },
  mutations: {
    updateField,
    SET_AOP(state, payload) {
      state.aops = payload;
    },
    SET_REGION(state, payload) {
      state.regions = payload;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async getAop({ commit }, obj) {
      const { data } = await axios.get(`${url}/area-operacional`, {});
      commit('SET_AOP', data);
    },
    // eslint-disable-next-line no-unused-vars
    async getRegion({ commit }, obj) {
      const { data } = await axios.get(`${url}/regiao-mb`, {});
      commit('SET_REGION', data);
    },
  },
  getters: { getField },
};
